module.exports = __webpack_public_path__ + "img/empty-page.45b405e9.svg";